var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedVerify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34892_118896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3399 8.61395C13.3399 12.0049 11.0059 13.7004 8.23166 14.6838C8.08639 14.7338 7.92859 14.7314 7.78485 14.677C5.00398 13.7004 2.66992 12.0049 2.66992 8.61395V3.86662C2.66992 3.49206 2.96849 3.18843 3.3368 3.18843C4.67055 3.18843 6.33773 2.3746 7.4981 1.34375C7.78997 1.09015 8.21987 1.09015 8.51175 1.34375C9.67878 2.38138 11.3393 3.18843 12.673 3.18843C13.0414 3.18843 13.3399 3.49206 13.3399 3.86662V8.61395Z",
    stroke: "#5B6779",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.00688L7.33333 9.34188L10 6.67188",
    stroke: "#5B6779",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34892_118896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedVerify);
export default __webpack_public_path__ + "static/media/checkedVerify.26bea996dcddf6dc966066eabc62d0e6.svg";
export { ForwardRef as ReactComponent };